<template>
  <div class="orderDetail">
    <topNav :title="$t('orderDetail_title')"
            url="/orderList"></topNav>
    <div class="warp"
         v-if="orderInfo.masterBase">
      <div class="orderSta clearfix">
        <div class="Num">{{$t('orderDetail_crsNo')}}:
          <span>{{ orderInfo.masterBase.crsNo == '' ? orderInfo.masterBase.rsvNo : orderInfo.masterBase.crsNo}}</span>
        </div>
        <div class="sta">{{$t('orderDetail_sta')}}:
          <span>{{orderInfo.masterBase.sta}}</span>
        </div>
      </div>
      <div class="infoList">
        <div class="info">
          <div class="infoTop">
            <i class="iconfont icon-changfangxingbiaoqian"></i>
            {{$t('orderDetail_checkIn_info')}}
          </div>
          <ul class="infoContent"
              v-for="item in noPain"
              :key="item.id">
            <li>{{$t('orderDetail_rsvArrDate')}}:
              <!--              <span class="infoVal">{{item.rsvArrDate | dateF}}</span>-->
              <span class="infoVal">{{item.rsvArrDate}}</span>
            </li>
            <li>{{$t('orderDetail_rsvDepDate')}}:
              <!--              <span class="infoVal">{{item.rsvDepDate | dateF}}</span>-->
              <span class="infoVal">{{item.rsvDepDate}}</span>
            </li>
            <li>{{$t('orderDetail_rmtypes')}}:
              <span class="infoVal">{{getRmType(item.rmtype)}}*{{item.rmnum}}{{$t('orderDetail_rmtypes_unit')}}</span>
            </li>
            <li class="clearfix">
              <div class="paiF"
                   @click="gearRoom(item)"
                   v-if="!item.rmno && ($hasPermission('mh!resrv!assign',rights.indexOf('resrv!assignroom') >= 0))">
                {{$t('orderDetail_paiF')}}
              </div>
            </li>
          </ul>
          <ul class="infoContent twocol "
              v-for="item in orderInfo.masterLinkList"
              :key="item.id">
            <li class="p100" :id="'r'+item.masterBase.rmno">{{$t('orderDetail_arr')}}:
              <!--              <span class="infoVal">{{item.masterBase.arr | dateF}} </span>-->
              <span class="infoVal">{{item.masterBase.arr}} </span>
              <div class="addGuest"
                   @click="addGuest(item)"
                   v-if="(item.masterBase.sta == 'R' || item.masterBase.sta == 'I') && $hasPermission('mh!recpt!edit', rights.indexOf('recept!fit!ci') >= 0)">
                <i class="iconfont icon-jia"></i>
              </div>
            </li>
            <li class="p100">{{$t('orderDetail_dep')}}:
              <!--              <span class="infoVal">{{item.masterBase.dep | dateF}}</span>-->
              <span class="infoVal">{{item.masterBase.dep}}</span>
            </li>
            <li>{{$t('orderDetail_rmtypes')}}:
              <span class="infoVal">{{getRmType(item.masterBase.rmtype)}}</span>
            </li>
            <li>{{$t('orderDetail_realRate')}}:
              <span class="infoVal"><small>￥</small>{{item.masterBase.realRate}}
                <i class="mintui mintui-more"
                   @click="getEveryDateRate(item.masterBase)"></i></span>
            </li>
            <li>{{$t('orderDetail_name')}}:
              <span class="infoVal">{{item.masterGuest.name}}</span>
            </li>
            <li>{{$t('orderDetail_sex')}}:
              <span class="infoVal">{{item.masterGuest.sex == 1? $t('orderDetail_sex1'): (item.masterGuest.sex == 2?$t('orderDetail_sex2'):'')}}</span>
            </li>
            <li>{{$t('orderDetail_mobile')}}:
              <span class="infoVal">{{item.masterGuest.mobile}}</span>
            </li>
            <li class="p100">{{$t('orderDetail_idNo')}}:
              <span class="infoVal">{{item.masterGuest.idNo}}
                <i class="iconfont icon-credentials_icon"
                   @click="getFirstToken(item)"
                   style="margin-left:0.5rem;color:#999;margin-top: 0.1rem;"
                   v-if="isJingJiang && $hasPermission('mh!recpt!edit', true)"></i>
                <template v-else>
                <i class="iconfont icon-saoma"
                   @click="sfzRe(item)"
                   v-if="sfzR && $hasPermission('mh!recpt!edit', rights.indexOf('recept!fit!ci') >= 0)"
                   style="margin-left:0.5rem;color:#999"></i>
                  </template>
              </span>
            </li>
            <li class="p100">{{$t('orderDetail_rsvNo')}}:<span>
                <router-link tag="span"
                             :to="'/fangTXQ?id='+item.masterBase.id+'&redirect=/orderDetail%3frsvNo%3d'+orderInfo.masterBase.rsvNo"> {{item.masterBase.rmno}} <i
                  class="mintui mintui-more"></i></router-link>
              </span>

              <div class="menka"
                   v-if='isJingJiang'
                   @click='openJingJiangModal(item.masterBase)'>门卡
              </div>
              <div class="ruZ"
                   @click='checkIn(item.masterBase.id)'
                   v-if="item.masterBase.sta=='R' && $hasPermission('mh!resrv!checkin',rights.indexOf('recept!fit!ci') >= 0)">入住
              </div>
              <div class="paiF"
                   v-else-if="item.masterBase.sta=='I'">{{$t('orderDetail_staI')}}
              </div>
              <div class="paiF"
                   v-else-if="item.masterBase.sta=='O'">{{$t('orderDetail_staO')}}
              </div>
              <div class="paiF"
                   v-else-if="item.masterBase.sta=='S'">{{$t('orderDetail_staS')}}
              </div>
              <div class="paiF"
                   v-else-if="item.masterBase.sta=='X'">{{$t('orderDetail_staX')}}
              </div>
            </li>
          </ul>
          <div class="totalmoney"
               v-if="orderInfo.masterBase.realRate > 0"
               style='margin-top:10px;'>
            {{$t('orderDetail_realRate')}}:
            <span><small>￥</small>{{orderInfo.masterBase.realRate}} <span style="color:red"
                                                                          v-if="orderInfo.masterBase.isSecretRate=='T'">{{$t('orderDetail_isSecretRate')}}</span></span>
          </div>
          <div class="totalmoney">
            {{$t('orderDetail_totalmoney')}}:
            <span><small>￥</small>{{orderInfo.feeTotal}} <span style="color:red"
                                                               v-if="orderInfo.masterBase.isSecretRate=='T'">{{$t('orderDetail_isSecretRate')}}</span></span>
          </div>
        </div>
        <div class="info ">
          <div class="infoTop">
            <i class="iconfont icon-changfangxingbiaoqian"></i>
            <!-- 预订信息 -->

            {{$t('orderDetail_bookInfo')}}
          </div>
          <ul class="infoContent twocol">
            <!-- 预订人 -->
            <li  class="p100">{{$t('orderDetail_bookName')}}:
              <span class="infoVal">{{orderInfo.masterGuest.name}}
                <i class="iconfont icon-xiugai"
                   v-if="orderInfo.masterBase.sta == 'R'"
                   @click="updatePersonInfo"></i></span>
            </li>
            <!-- 手机 -->
            <li class="p100">{{$t('orderDetail_mobile')}}:<span class="infoVal">
                <a :href='"tel:"+orderInfo.masterGuest.mobile'>{{orderInfo.masterGuest.mobile}}</a>
              </span>
            </li>

            <!-- 卡号 -->
            <li class="p100">{{$t('orderDetail_memberNo')}}:<span class="infoVal">{{orderInfo.masterBase.memberNo}}</span></li>
            <!-- 抵店 -->
            <li class="p100">{{$t('fangTXQ_arr')}}:<span class="infoVal">{{orderInfo.masterBase.arr}}</span>
            </li>
<!--            离店-->
            <li class="p100">{{$t('fangTXQ_dep')}}:<span class="infoVal">{{orderInfo.masterBase.dep}}</span>
            </li>
            <!-- 协议公司 -->
            <li class="p100">{{$t('fangTXQ_companyName')}} :<span
              class="infoVal">{{orderInfo.masterBase.companyName}}</span></li>
            <!-- 旅行社 -->
            <li class="p100">{{$t('fangTXQ_agentName')}}:<span class="infoVal">{{orderInfo.masterBase.agentName}}</span>
            </li>
            <!-- 订房中心 -->
            <li class="p100">{{$t('fangTXQ_sourceName')}}:<span
              class="infoVal">{{orderInfo.masterBase.sourceName}}</span></li>
          </ul>
        </div>
        <div class="info">
          <div class="infoTop">
            <i class="iconfont icon-changfangxingbiaoqian"></i>
            <!-- 市场销售 -->
            {{$t('fangTXQ_market_sales')}}
          </div>
          <ul class="infoContent twocol">
            <!-- 销售 -->
            <li>{{$t('fangTXQ_salesman')}}:
              <span class="infoVal">{{orderInfo.masterBase.salesman}}</span>
            </li>
            <!-- 预订类型 -->
            <li>{{$t('fangTXQ_rsvTypeName')}}:
              <span class="infoVal">{{orderInfo.masterBase.rsvTypeName}}</span>
            </li>
            <!-- 市场 -->
            <li class="p100"> {{$t('book_market')}}:

              <span class="infoVal">{{orderInfo.masterBase.market}}</span>
            </li>
            <!-- 来源 -->
            <li class="p100">{{$t('book_src')}} :
              <span class="infoVal">{{orderInfo.masterBase.src}}</span>
            </li>
            <!-- 房价码 -->
            <li>{{$t('fangTXQ_market')}}:<span class="infoVal">{{orderInfo.masterBase.ratecode}}</span></li>
            <!-- 渠道 -->
            <li>{{$t('fangTXQ_channel')}}:
              <span class="infoVal">{{orderInfo.masterBase.channel}}</span>
            </li>
            <!-- 佣金码 -->
            <li>{{$t('fangTXQ_cmscode')}}:
              <span class="infoVal">{{orderInfo.masterBase.cmscode}}</span>
            </li>
            <!-- 付款码 -->
            <li>{{$t('fangTXQ_payCode')}}:
              <span class="infoVal">{{orderInfo.masterBase.payCode}}</span>
            </li>
            <!-- 中央预订号 -->
            <li class="p100">{{$t('fangTXQ_crsNo')}}:
              <span class="infoVal">{{orderInfo.masterBase.crsNo}}</span>
            </li>
            <!-- 包价 -->
            <li class="p100">{{$t('fangTXQ_packagesDis')}}:
              <span class="infoVal">{{orderInfo.masterBase.packagesDis}}</span>
            </li>
            <li class="p100">{{$t('fangTXQ_creditMan')}}:
              <span class="infoVal">{{orderInfo.masterBase.creditMan}}</span>
            </li>
            <li class="p100">{{$t('fangTXQ_otaRsvNo')}}:
              <span class="infoVal"
                    style="color:red">{{orderInfo.masterBase.otaRsvNo}}</span>
            </li>
          </ul>
        </div>
        <div class="info">
          <div class="infoTop">
            <i class="iconfont icon-changfangxingbiaoqian"></i>
            <!-- 预收款信息 -->

            {{$t('orderDetail_payment_info')}}
          </div>
          <ul class="infoContent">
            <!-- 预收款 -->
            <li>{{$t('orderDetail_pay')}}:
              <span class="infoVal">￥{{orderInfo.masterBase.pay.toFixed(2)}}</span>
            </li>
            <!-- 预授权 -->
            <li>{{$t('orderDetail_credit')}}:
              <span class="infoVal">￥{{orderInfo.masterBase.credit.toFixed(2)}}</span>
            </li>
            <!-- 余额 -->
            <li>{{$t('orderDetail_charge')}}:
              <span class="infoVal">￥{{(orderInfo.masterBase.charge - orderInfo.masterBase.pay).toFixed(2)}}</span>
            </li>
            <!-- 结账提醒： -->
            <li v-if="orderInfo.masterBase.coMsg"
                class="ha"> {{$t('fangTXQ_coMsg')}}：<span style="color:red">{{orderInfo.masterBase.coMsg}}</span>
            </li>
          </ul>
        </div>
        <div class="info"
             style="padding-top:2000;"
             id="sss">
          <div class="infoTop">
            <i class="iconfont icon-changfangxingbiaoqian"></i>
            <!-- 其他 -->

            {{$t('other')}}

          </div>
          <ul class="infoContent"
              style="border-bottom:0">
            <li class="ha"> {{$t('fangTXQ_amenities')}}:
              <span class="infoVal">{{orderInfo.masterBase.amenities}}</span>
            </li>
            <li class="ha"> {{$t('fangTXQ_specials')}}:
              <span class="infoVal">{{orderInfo.masterBase.specials}}</span>
            </li>

            <!-- 备注 -->
            <li class="ha">{{$t('fangTXQ_remark')}} :
              <span class="infoVal">{{orderInfo.masterBase.remark}}
                <i class="iconfont icon-xiugai"
                   @click="updateRemark"
                   v-if="$hasPermission('mh!resrv!cmme!up',rights.indexOf('resrv!fit!edit') >= 0)"></i>
              </span>
            </li>
            <!-- 创建人 -->
            <li> {{$t('fangTXQ_createUser')}}:
              <span class="infoVal">{{orderInfo.masterBase.createUser}}</span>
            </li>
            <!-- 创建时间 -->
            <li> {{$t('fangTXQ_createDatetime')}}:
              <span class="infoVal">{{orderInfo.masterBase.createDatetime}}</span>
            </li>
            <!-- 修改人 -->
            <li>{{$t('fangTXQ_modifyUser')}}:
              <span class="infoVal">{{orderInfo.masterBase.modifyUser}}</span>
            </li>
            <!-- 修改时间 -->
            <li>{{$t('fangTXQ_modifyDatetime')}}:
              <span class="infoVal">{{orderInfo.masterBase.modifyDatetime}}</span>
            </li>
          </ul>
        </div>
      </div>
      <!-- 我是有底线的 -->
      <div class="dx">
        <span> {{$t('loading_end_message')}} </span>
      </div>
      <mt-palette-button content="+"
                         direction="lt"
                         class="pb"
                         :radius="80"
                         ref="target_1"
                         mainButtonStyle="color:#fff;background-color:#f6a624;"
                         style="right:30px;">
        <div class="my-icon-button indexicon icon-popup"
            v-if="useQrcodePay"
             @click="showQrcodeModal" ><i class="iconfont icon-dingdan"></i></div>
        <div class="my-icon-button indexicon icon-popup"
             @click="sub_log();searchRoomVisible=true">
          <i class="iconfont icon-sousuo"></i></div>

        <div class="my-icon-button indexicon icon-popup"
             v-if="$hasPermission('mh!resrv!pay', rights.indexOf('act!posting') >= 0)"
             @click="doCheckShift('goIncomeAccount')"><i class="iconfont icon-JZQK"></i></div>

        <div class="my-icon-button indexicon icon-popup"
             v-if='isJingJiang'
             @click="openPrintSelectModal">
          <i class="iconfont icon-dayin"></i>
        </div>

        <div class="my-icon-button indexicon icon-popup"
             v-if="orderInfo.masterBase.sta=='R' && ($hasPermission('mh!resrv!cancel',rights.indexOf('resrv!fit!cxl') >= 0)) "
             @click="sub_log();cancelOrder()">
          <i class="iconfont icon-cuowu"></i>
        </div>
      </mt-palette-button>
    </div>

    <selectShift ref="selectShiftRef"
                 @success="setShift"></selectShift>

    <mt-popup v-model="popupVisible"
              position="right"
              class="setroom"
              :modal="false">
      <!-- <div class=" setroom " style="display: none"> -->
      <div class="top">
        <i class="iconfont icon-zuo"
           @click="canclePop"></i>
        <!-- 排房/入住 -->

        {{$t('orderDetail_checkin')}}

        <!-- 确定 -->
        <div class="sureGear"
             @click='submitGear'>{{$t('determine')}}
        </div>
      </div>
      <div class="infoTitle">
        {{gearRoomInfo.rmtype}} {{gearRoomInfo.rmnum}} {{$t('index_homeData_analy_unit')}}
      </div>

      <div class="optional selected clearfix">
        <div class="option"
             v-for="n in gearRoomInfo.rmnum"
             :key="n"
             :class="{rowDatas:!!confineRoom[n]&&confineRoom[n].type=='rowDatas',InDatas:!!confineRoom[n]&&confineRoom[n].type=='InDatas'}">
          {{confineRoom[n] | showConfine}}
          <div class="cleartext"
               v-show="confineRoom[n]"
               @click="vShowDelete(n)">
            <i class="iconfont icon-cuowu"></i>
          </div>
        </div>
      </div>

      <div class="room-status-select">
        <div class="status-select-title">{{$t('fangT_title')}}</div>
        <div>
          <span v-for="(item,index) in roomStatusArr"
                @click="chooseRoomStatus(item)"
                class="status-item"
                :class="{active: item.isActive}"
                :key="'roomStatusArr' + index">
            {{item.name}}
          </span>
        </div>
      </div>

      <div class="optional"
           style="height:65%;overflow-y: scroll;">
        <div class="option"
             v-for="item in gearRoomInfo.roomStatus"
             :key="item"
             @click='selectRoom(item)'
             :class='{choose:selectedroom.indexOf(item)!=-1}'>{{item}}
        </div>
      </div>
      <div class="bottom">
        <!-- 排房-->
        <div class="plan"
             @click='pushSelected(0)'>{{$t('orderDetail_paiF')}}
        </div>
        <!-- 入住-->
        <div class="checkIn"
             @click='pushSelected(1)'>{{$t('fangT_walkBook')}}
        </div>
      </div>
      <!-- </div> -->
    </mt-popup>
    <mt-popup v-model="guestPopVisible"
              v-if="updateGuest"
              class='guestInfo'
              popup-transition="popup-fade">
      <!-- 住客信息-->
      <h2> {{$t('orderDetail_guest_info')}}</h2>

      <div class="guestSwiper">
        <!-- 房号：-->
        <p>{{$t('fangTXQ_rmno')}}：
          <span class="formRoomNum"> {{updateGuest.masterBase.rmno}}</span>
        </p>
        <div class="infoToWrite">
          <!-- 姓名 请输入姓名-->
          <mt-field :label="$t('fangTXQ_name')"
                    :placeholder="$t('orderDetail_guest_name_placeholder')"
                    v-model='updateGuest.masterGuest.name'></mt-field>
          <!-- 证件号码 请输入证件号码-->
          <mt-field :label="$t('fangTXQ_idNo')"
                    :placeholder="$t('fangTXQ_idNo_placeholder')"
                    v-model='updateGuest.masterGuest.idNo'></mt-field>
          <mt-field :label="$t('orderDetail_mobile')"
                    :placeholder="$t('orderDetail_mobile_placeholder')"
                    v-model='updateGuest.masterGuest.mobile'></mt-field>
        </div>

      </div>

      <div class="btn">
        <!-- 取消-->
        <div class="unSure"
             @click="cancleGuestPop">{{$t('cancel')}}
        </div>
        <!-- 确定-->
        <div class="sure"
             @click="changGuest">{{$t('determine')}}
        </div>
      </div>
    </mt-popup>
    <updateRemark ref="upRemark"
                  @success="getOrderDetail"></updateRemark>
    <mt-popup v-model="searchRoomVisible"
              class='guestInfo'
              style="width:80%;height:250px"
              popup-transition="popup-fade">
      <!-- 搜索本订单房间-->
      <h2>{{$t('orderDetail_search_room')}} </h2>
      <div class="guestSwiper"
           style="margin-top:15px">
        <div class="infoToWrite">
          <!-- 房号 请输入房号-->

          <mt-field :label="$t('fangT_rmno')"
                    :placeholder="$t('fangT_rmno_placeholder')"
                    v-model="searchRmno"></mt-field>
          <!-- 姓名 请输入姓名-->
          <mt-field :label="$t('orderDetail_guest_name') "
                    :placeholder="$t('orderDetail_guest_name_placeholder')"
                    v-model="searchName"></mt-field>
        </div>
      </div>
      <div class="btn">
        <!--取消-->
        <div class="unSure"
             @click="searchRoomVisible=false">{{$t('cancel')}}
        </div>
        <!--确定-->
        <div class="sure"
             @click="searchRoom">{{$t('determine')}}
        </div>
      </div>
    </mt-popup>
    <mt-popup v-model="popupEvalDay"
              position="bottom"
              class="everyDatePop"
              :modal="true">
      <table class="checkList"
             align='center'
             style="border-collapse:collapse;">
        <tbody>
        <tr>
          <!--日期-->
          <th width="20%">{{$t('fangQ_date')}}</th>
          <!--房价-->
          <th width="35%">{{$t('book_reason')}}</th>
          <th width="25%">{{$t('fangTXQ_realRate')}}</th>
          <!--房间数-->
          <th width="20%">{{$t('fangTXQ_rmnum')}}</th>
        </tr>
        </tbody>
        <tr>
          <!--合计-->
          <td>{{$t('fangTXQ_total')}}</td>
          <td></td>
          <td>{{sumRate(dateRate)}}</td>
          <td></td>
        </tr>
        <tr v-for="item in dateRate"
            :key="item.rsv_date">
          <td>{{item.rsv_date | dateF}}</td>
          <td>{{reasonObj[item.dscResaon] || ''}}</td>
          <td>
            <small>￥</small>
            {{item.realShareRate}}
          </td>
          <td>{{item.rmnum}}</td>
        </tr>
      </table>
    </mt-popup>

    <jingJiangModal ref="jingJiang"
                    @success="closeJingJiangModal"></jingJiangModal>


    <div class='door-card-modal'
         v-if='doorCardModalShow'>
      <div class='door-card-container'>
        <div class='door-card-title'>{{$t('jj_door_card_info')}}</div>
        <div class='door-card-info'>
          <div class='info-item'>
            <div class='info-item-label'>{{$t('jj_room_no')}}：</div>
            <div class='info-item-content'>{{ResponseParameters.roomNo}}</div>
          </div>
          <div class='info-item'>
            <div class='info-item-label'>{{$t('jj_beginTime')}}：</div>
            <div class='info-item-content'>{{ResponseParameters.beginTime}}</div>
          </div>
          <div class='info-item'>
            <div class='info-item-label'>{{$t('jj_endTime')}}：</div>
            <div class='info-item-content'>{{ResponseParameters.endTime}}</div>
          </div>
        </div>

        <div class='door-card-bottom'>
          <div class='door-btns'
               @click='closeDoorCardModal'>{{$t('determine')}}
          </div>
        </div>
      </div>
    </div>


    <div class='print-select-modal'
         v-if='printSelectModalShow'>
      <div class='door-card-container'>
        <div class='door-card-title'>打印</div>
        <div class='modal-container'>
          <div class='spe-row'>
            <div class='btn-default'
                 @click='getListBillSceneLink("RECEPT")'>打印登记单
            </div>
            <div class='btn-default'
                 @click='getListDeposit'>打印定金单
            </div>
          </div>
          <div class='spe-row'>
            <div class='btn-default'
                 @click='getListBillSceneLink("FO_BILL")'>打印账单
            </div>
          </div>
        </div>
        <div class='door-card-bottom'>
          <div class='door-btns'
               @click='closePrintSelectModal'>{{$t('cancel')}}
          </div>
        </div>
      </div>
    </div>

    <mt-popup v-model="showPop"
              class='selectShift select-wrap'
              popup-transition="popup-fade">
      <!--班别选择-->
      <h2>押金记录</h2>
      <div class='select-list-wrap'>
        <mt-radio
          v-model="currentCode"
          :options="listDeposit">
        </mt-radio>
      </div>
      <div class="btn">
        <div class="unSure"
             @click="showPop=false">{{$t('cancel')}}
        </div>
        <div class="sure"
             @click="save">{{$t('determine')}}
        </div>
      </div>
    </mt-popup>
    <mt-popup v-model="showPop2"
              class='selectShift select-wrap'
              popup-transition="popup-fade">
      <h2>选择场景</h2>
      <div class='select-list-wrap'>
        <mt-radio
          v-model="currentCode2"
          :options="listBillSceneLink">
        </mt-radio>
      </div>
      <div class="btn">
        <div class="unSure"
             @click="showPop2=false">{{$t('cancel')}}
        </div>
        <div class="sure"
             @click="save2">{{$t('determine')}}
        </div>
      </div>
    </mt-popup>


    <mt-popup v-model="changeBaseInfoModal"
              class='guestInfo base-spe'
              popup-transition="popup-fade">
      <!-- 住客信息-->
      <h2> {{ $t('orderDetail_bookName')  }} </h2>
      <div class="guestSwiper">
        <div class="infoToWrite">
          <!-- 姓名 请输入姓名-->
          <mt-field :label="$t('fangTXQ_name')"
                    :placeholder="$t('orderDetail_guest_name_placeholder')"
                    v-model='tempObj.userName'></mt-field>
          <mt-field :label="$t('orderDetail_mobile')"
                    :placeholder="$t('orderDetail_mobile_placeholder')"
                    type="number"
                    v-model='tempObj.mobile'></mt-field>
        </div>
      </div>
      <div class="btn">
        <!-- 取消-->
        <div class="unSure"
             @click="cancleBasePop">{{ $t('cancel') }}
        </div>
        <!-- 确定-->
        <div class="sure"
             @click="changeBaseInfo">{{ $t('determine') }}
        </div>
      </div>
    </mt-popup>

    <form-qr-code-modal ref="formQrCodeModal" @emitFormQrCode="emitFormQrCode"></form-qr-code-modal>
    <qrcode-modal ref="qrCodeModal"></qrcode-modal>

  </div>
</template>

<script>
  import _ from 'lodash';
  import updateRemark from './fangTXQ/fangTXQ-comp/updateRemark';
  import {
    Swipe,
    SwipeItem,
    Toast,
    MessageBox
  } from 'mint-ui';
  import selectShift from '../common/selectShift';
  import jingJiangModal from './fangTXQ/fangTXQ-comp/jingJiangModal';

  import formQrCodeModal from './fangTXQ/fangTXQ-comp/formQrCodeModal';
  import qrcodeModal from './fangTXQ/fangTXQ-comp/qrcodeModal';

  export default {
    data() {
      return {
        orderInfo: {}, //订单详细
        popupVisible: false,
        currentRoom: {},
        gearRoomInfo: {}, //排房前信息
        selectedroom: [],
        confineRoom: [{
          rmnum: '1',
          type: ''
        }],
        gearOption: {
          //排房请求信息
          InDatas: [],
          rowDatas: [],
          rsvId: '',
          rsvNo: '',
          masterId: ''
        },
        guestPopVisible: false,
        guestInfoCache: {},
        noPain: [],
        dateRate: [],
        updateGuest: null,
        popupEvalDay: false,
        searchRoomVisible: false,
        searchRmno: '',
        searchName: '',
        sfzR: null,
        rights: [],
        actionType: '',
        currentShift: {}, // 当前的班次
        roomStatusArr: [{
          name: this.$t('fangT_RoomStaD'),
          value: 'D',
          isActive: false,
        }, {
          name: this.$t('fangT_RoomStaR'),
          value: 'R',
          isActive: false,
        }, {
          name: this.$t('fangT_RoomStaI'),
          value: 'I',
          isActive: false,
        },],
        reasonObj: {},

        // 锦江刷身份证
        isJingJiang: localStorage.getItem('isJingJiang') == 'yes',
        jingJiangToken: '',
        chainNo: '',
        Key: '',
        secretKey: '',
        currentItem: {}, // 当前操作的对象
        doorCardModalShow: false,
        ResponseParameters: {
          roomNo: '',
          beginTime: '',
          endTime: '',
        },
        tempRoomNo: '',
        listened: false,


        //锦江打印
        printSelectModalShow: false,
        listDeposit: [],
        listBillSceneLink: [],
        showPop: false,
        showPop2: false,
        currentCode: '',
        currentCode2: '',
        accnt: '',
        sceneCode: '',

        // 修改预订人信息
        changeBaseInfoModal: false,
        tempObj: {
          userName: '',
          mobile: ''
        },

        // 判断是否显示生成二维码支付功能
        useQrcodePay: localStorage.getItem('useQrcodePay') == 'yes',
      }
    },
    mounted() {
      this.getLocalSelectedRoomStatus()
      this.getOrderDetail();
      this.getReasonList();
      this.getLocalShift()
      this.initJingJiangListen()
    },
    methods: {
      updatePersonInfo(){
        var orderInfo = this.orderInfo || {}
        var masterGuest = orderInfo.masterGuest || {}
        this.tempObj = {
          userName: masterGuest.name,
          mobile: masterGuest.mobile
        }
        this.changeBaseInfoModal = true
      },

      changeBaseInfo(){
        var temp = this.tempObj  || {}
        if(!temp.userName){
          this.msg2(this.$t('orderDetail_guest_name_placeholder'))
          return
        }
          this.$http
            .post("/mobilepmsapi/reception/updateResrvMobileName", {
              id: this.orderInfo.masterBase.id,
              userName: temp.userName,
              mobile: temp.mobile,
            })
            .then(res => {
              if (res.data.result == 0) {
                this.msg2(this.$t('msg_modify_success'));
                this.cancleBasePop()
              } else {
                this.msg2(res.data.msg);
              }
            });
      },
      cancleBasePop(){
        this.changeBaseInfoModal = false;
        this.getOrderDetail();
      },

      save() {
        this.getDepositBillPdf(this.currentCode)
        this.showPop = false
      },
      save2() {
        if (this.sceneCode == 'RECEPT') {
          this.getOrderBillPdf(this.currentCode2)
        } else {
          this.getConsumptionBillPdf(this.currentCode2)
        }
        this.showPop2 = false
      },
      // 登记单
      getOrderBillPdf(billCode) {
        const self = this
        this.$http.post('/mobilepmsapi/print/getOrderBillPdf', {
          hotelCode: localStorage.getItem('hotelCode'),
          hotelGroupId: localStorage.getItem('hotelGroupId'),
          hotelId: localStorage.getItem('hotelId'),
          billCode: billCode,
          accnt: this.orderInfo.masterBase.id,
        }).then(res => {
          if (res.data.result == 0) {
            self.downloadPdf(res.data.retVal)
          } else {
            self.msg2(res.data.msg)
          }
        });
      },
      getConsumptionBillPdf(billCode) {
        const self = this
        this.$http.post('/mobilepmsapi/print/getConsumptionBillPdf', {
          hotelCode: localStorage.getItem('hotelCode'),
          hotelGroupId: localStorage.getItem('hotelGroupId'),
          hotelId: localStorage.getItem('hotelId'),
          billCode: billCode,
          accnt: this.orderInfo.masterBase.id,
        }).then(res => {
          if (res.data.result == 0) {
            self.downloadPdf(res.data.retVal)
          } else {
            self.msg2(res.data.msg)
          }
        });
      },
      // 打印预订单
      getDepositBillPdf(billDataId) {
        const self = this
        this.$http.post('/mobilepmsapi/print/getDepositBillPdf', {
          hotelCode: localStorage.getItem('hotelCode'),
          hotelGroupId: localStorage.getItem('hotelGroupId'),
          hotelId: localStorage.getItem('hotelId'),
          billDataId: billDataId,
          accnt: this.orderInfo.masterBase.id,
        }).then(res => {
          if (res.data.result == 0) {
            self.downloadPdf(res.data.retVal)
          } else {
            self.msg2(res.data.msg)
          }
        });
      },
      getListDeposit() {
        const self = this
        self.listDeposit = []
        this.$http.post(`/mobilepmsapi/print/listDeposit`, {
          accnt: this.orderInfo.masterBase.id  // 0 或者 3267, 取登记单的 id
        }).then(res => {
          if (res.data.result == 0) {
            let arr = res.data.retVal || []
            if (arr.length > 0) {
              arr.map((item, index) => {
                // 为了使用 mint ui的 radio，格式改一下
                item.label = item.taDescript + ' - ' + item.pay + '元'
                item.value = (item.id + '') || ''
                self.listDeposit.push(item)
              })
              this.showPop = true
            } else {
              self.msg2('没有查询到押金记录')
            }
          } else {
            self.msg2(res.data.msg)
          }
        });
      },
      getListBillSceneLink(sceneCode) {
        const self = this
        self.sceneCode = sceneCode
        self.listBillSceneLink = []
        this.$http.post(`/mobilepmsapi/print/listBillSceneLink`, {
          sceneCode: sceneCode, // 'FO_BILL' || 'RECEPT'
        }).then(res => {
          if (res.data.result == 0) {
            let arr = res.data.retVal || []
            if (arr.length > 0) {
              arr.map((item, index) => {
                // 为了使用 mint ui的 radio，格式改一下
                item.label = item.code + ' - ' + item.descript
                item.value = (item.code + '') || ''
                self.listBillSceneLink.push(item)
              })
              this.showPop2 = true
            } else {
              // self.msg2('没有查询到押金记录')
            }
          } else {
            self.msg2(res.data.msg)
          }
        });
      },
      openPrintSelectModal() {
        this.printSelectModalShow = true
      },
      closePrintSelectModal() {
        this.printSelectModalShow = false
      },
      initJingJiangListen() {
        let that = this
        if (this.isJingJiang && !this.listened) {
          this.listened = true
          document.addEventListener('resume', function () {
            that.closeDoorCardModal()
            let arg = plus.runtime.arguments || ''
            // let arg = 'mihotel://beginTime=2020-0-18 00:00&endTime=2020-05-19 12:00&roomNo=0000&page=fangT&chainNo=1234'
            let lastInvokeId = localStorage.getItem('lastInvokeId') || ''
            // alert('orderDetail被唤醒，参数是：' + arg + ', listened'+ that.listened + ','+ that.$route.name + ',' + lastInvokeId)
            //从后台切换到前台
            if (arg != '' && that.$route.name == 'orderDetail') {
              try {
                let temp = arg.split('//') || []
                let str = temp[1] || ''
                if (str) {
                  let aj = that.parseQueryString(str)
                  let roomNo = aj.roomNo || ''
                  // alert('orderDetail lastInvokeId: ' + lastInvokeId + ', ajId: ' + aj.id)
                  if (lastInvokeId && lastInvokeId == aj.id) {
                    // that.msg2('重复读卡')
                  } else {
                    setTimeout(() => {
                      localStorage.setItem('lastInvokeId', aj.id)
                    }, 500)
                    if (roomNo) {
                      if (roomNo == '0') {
                        that.msg2(that.$t('jj_empty_card'))
                      } else {
                        that.doorCardModalShow = true
                        that.tempRoomNo = roomNo
                        that.ResponseParameters = aj || {}
                      }
                    } else {
                      // that.msg2(this.$t('jj_empty_card'))
                    }
                  }
                }
                // 处理JSON对象aj
              } catch (e) {
                // 若传入的参数不是JSON格式字符，需处理异常情况
              }
            }
          }, false);
        }
      },
      closeDoorCardModal() {
        this.tempRoomNo = ''
        this.ResponseParameters = {
          roomNo: '',
          beginTime: '',
          endTime: '',
        }
        this.doorCardModalShow = false
      },
      // 锦江门卡操作
      openJingJiangModal(masterBase) {
        this.sub_log()
        masterBase.roomNo = masterBase.rmno
        this.$refs.jingJiang.show(masterBase || {});
      },
      closeJingJiangModal() {

      },
      getFirstToken(item) {
        this.currentItem = item || {}
        this.getJingJiangToken()
      },
      // 锦江读身份证
      jingjiangShuaka() {
        const self = this
        let obj = {
          'Key': this.Key,
          'Token': this.jingJiangToken,
          'Category': '1', // 1身份证 2身份证解码信息
          'EventName': 'Read',
          'CardType': 'IDCard',
          'isJingJiangLocal': true
        }
        this.wakeUpJingJiangApp('readIdCard')
        this.$http.post('/CardService/RequestForWrite', obj).then(res => {
          if (res.data.result == 0) {
            self.msg2(self.$t('jj_id_card_read_success'))
            let guest = self.currentItem || {}
            let guestinfo = [];
            var retVal = res.data.retVal || {}
            let so = JSON.parse(retVal.ResponseParameters || "{}") || {}
            guestinfo.push({
              id: guest.masterBase.id,
              name: so.name,
              idNo: so.idnum,
              idCode: '01',
              address: so.address,
              sex: so.sex,
              birthday: so.birthDate,
              national: so.nation
            });
            console.log(guestinfo);
            self.$http
              .post('/mobilepmsapi/reception/updateMasterGuest', guestinfo)
              .then(res => {
                if (res.data.result == 0) {
                  guest.masterGuest.name = so.name;
                  guest.masterGuest.idNo = so.idnum;
                  self.msg2(self.$t('msg_update_success'));
                } else {
                  self.msg2(res.data.msg);
                }
              });
          } else {
            MessageBox.alert(res.data.msg)
          }
        });
      },
      getJingJiangToken(type) {
        let objStr = localStorage.getItem('JingJiangSetting') || '{}'
        let obj = JSON.parse(objStr)
        this.chainNo = obj.HotelId || ''
        this.Key = obj.Key || ''
        obj.isJingJiangLocal = true
        this.$http.post('/CardService/Authorize', obj).then(res => {
          if (res.data.result == 0) {
            let retVal = res.data.retVal || {}
            this.jingJiangToken = retVal.Token || '';
            this.jingjiangShuaka()
          } else {
            this.msg2(this.$t('jj_token_error'));
          }
        });
      },

      getReasonList() {
        this.$http
          .post('/mobilepmsapi/reception/listCodeReason')
          .then(res => {
            if (res.data.result == 0) {
              let reasonList = res.data.retVal.resultInfo || []
              let temp = {}
              reasonList.map((item, index) => {
                temp[item.code] = item.descript
              })
              this.reasonObj = temp
            } else {
              // this.msg2(res.data.msg);
            }
          });
      },

      getLocalSelectedRoomStatus() {
        let localSelectedRoomStatus = localStorage.getItem('selectedRoomStatus') || ''
        let arr = []
        if (localSelectedRoomStatus.length > 0) {
          arr = localSelectedRoomStatus.split(',')
        } else {
          arr = ['R', 'I']
        }
        if (arr.length) {
          this.roomStatusArr.map((item) => {
            if (arr.indexOf(item.value) > -1) {
              item.isActive = true
            }
          })
        } else {
          this.roomStatusArr.map((item) => {
            if (arr.indexOf(item.value) > -1) {
              item.isActive = true
            }
          })
        }
      },
      chooseRoomStatus(item) {
        console.log(item)
        item.isActive = !item.isActive
        let currentRoom = this.currentRoom || {}
        this.gearRoom(currentRoom)
      },

      // 判断班别是否存在
      doCheckShift(actionType = '') {
        this.actionType = actionType
        let currentShift = this.currentShift || {}
        if (currentShift.code) {
          this.doNext()
        } else {
          this.openSelectShift()
        }
      },

      doNext() {
        let actionType = this.actionType || ''
        if (actionType === 'goIncomeAccount') {
          this.goIncomeAccount()
        }
      },
      goIncomeAccount() {
        this.sub_log();
        this.$router.push('/ftxq/IncomeAccount' + this.formatUrlParam());
      },

      formatUrlParam() {
        var m = this.orderInfo;
        return '?id=' + m.masterBase.id +
          '&rmno=' +
          m.masterBase.rmno +
          '&name=' +
          m.masterGuest.name +
          '&redirect=' +
          encodeURIComponent('/orderDetail?rsvNo=' + this.$route.query.rsvNo)
      },

      sub_log() {
        this.$refs.target_1.collapse();
      },
      getLocalShift() {
        let localShift = localStorage.getItem('currentShift') || '';
        this.currentShift = localShift ? JSON.parse(localShift) : {}
      },

      openSelectShift() {
        let currentShift = this.currentShift || {}
        this.$refs.selectShiftRef.show(currentShift.code);
      },

      setShift(shiftItem = {}) {
        localStorage.setItem('currentShift', JSON.stringify(shiftItem));
        this.currentShift = shiftItem || {};
        this.doNext()
      },

      /*获取基本订单详情*/
      getOrderDetail() {
        this.$http
          .post(
            '/mobilepmsapi/reception/getOrderDetail?rsvNo=' +
            this.$route.query.rsvNo
          )
          .then(res => {
            if (res.data.result == 0) {
              this.orderInfo = res.data.retVal.fMasterDto;
              this.sfzR = this.orderInfo.sfzR;
              this.rights = res.data.retVal.rights;
              this.redoData();
            } else {
              this.msg2(res.data.msg);
            }
          });
      },
      updateRemark() {
        this.$refs.upRemark.show(this.orderInfo.masterBase.id, '');
      },
      redoData() {
        this.noPain = [];
        for (var i = 0; i < this.orderInfo.rsvSrcList.length; i++) {
          var b = this.orderInfo.rsvSrcList[i];
          if (b.rmnum > 0 && (b.rmno == null || b.rmno == '')) {
            this.noPain.push(b);
          }
        }
      },
      sfzRe(guest) {
        var A = plus.webview.getLaunchWebview();
        var that = this;
        window.sfzback = function (a) {
          var so = JSON.parse(a);
          if (so.error_code != 0) {
            that.msg(this.$t('msg_error_code'));
          } else {
            let guestinfo = [];
            guestinfo.push({
              id: guest.masterBase.id,
              name: so.name,
              idNo: so.id_number,
              idCode: '01',
              address: so.address,
              sex: so.sex,
              birthday: so.birthday,
              national: so.people
            });
            //console.log(guestinfo);
            that.$http
              .post('/mobilepmsapi/reception/updateMasterGuest', guestinfo)
              .then(res => {
                if (res.data.result == 0) {
                  guest.masterGuest.name = so.name;
                  guest.masterGuest.idNo = so.id_number;
                  this.msg2(this.$t('msg_modify_success'));
                } else {
                  this.msg2(res.data.msg);
                }
              });
          }
        };
        A.evalJS('getSFZ(\'' + that.sfzR + '\')');
      },
      getEveryDateRate(mb) {
        this.popupEvalDay = true;
        this.$http
          .post('/mobilepmsapi/reception/getEveryDateRate', {
            masterId: mb.id,
            arr: mb.arr,
            dep: mb.dep
          })
          .then(res => {
            this.dateRate = res.data.retVal;
          });
      },
      getRmType(v) {
        if (this.orderInfo.codes.rmtype == undefined) {
          return v;
        }
        var value = this.orderInfo.codes.rmtype[v];
        return value == null ? v : value;
      },
      sumRate(value) {
        var sum = 0;
        for (var i = 0; i < this.dateRate.length; i++) {
          sum += this.dateRate[i].realShareRate * this.dateRate[i].rmnum;
        }
        return sum;
      },

      getSelectedRoomStatus() {
        let stasArr = this.roomStatusArr.filter((item) => {
          return item.isActive
        })
        let stasValueStr = _.map(stasArr, 'value')
        let stasStr = stasValueStr.join(',')
        localStorage.setItem('selectedRoomStatus', stasStr)
        return stasStr
      },
      /*获取排房前信息*/
      gearRoom(value) {
        this.currentRoom = value || {}
        this.selectedroom = [];
        this.confineRoom = [{
          rmnum: '1',
          type: ''
        }];
        this.gearOption.InDatas = [];
        this.gearOption.rowDatas = [];

        this.$http.post('/mobilepmsapi/reception/getRowHouseInfo', {
          rsvId: value.id,
          rsvNo: this.orderInfo.masterBase.rsvNo,
          stas: this.getSelectedRoomStatus(), // 脏D  干净R 检查I
        })
          .then(res => {
            if (res.data.result == 0) {
              // console.log(res.data)
              this.gearRoomInfo = res.data.retVal;
              this.popupVisible = true;
              this.gearOption.masterId = this.gearRoomInfo.masterId;
              this.gearOption.rsvId = value.id;
              this.gearOption.rsvNo = this.orderInfo.masterBase.rsvNo;
            }
          });
        // })
      },
      sub_log() {
        this.$refs.target_1.collapse();
      },
      searchRoom() {
        if (this.searchRmno == '' && this.searchName == '') {
          //请输入搜索条件
          this.msg2(this.$t('msg_search'));
          return;
        }
        var sno = '';
        if (this.searchRmno != '') {
          sno = this.searchRmno;
        } else if (this.searchName != '') {
          for (var i = 0; i < this.orderInfo.masterLinkList.length; i++) {
            var lmast = this.orderInfo.masterLinkList[i];
            if (
              lmast.masterGuest.name != null &&
              lmast.masterGuest.name.indexOf(this.searchName) >= 0
            ) {
              sno = lmast.masterBase.rmno;
              break;
            }
          }
        }
        if (sno == '') {
          this.msg2(this.$t('msg_could_not_find'));
          return;
        }
        try {
          this.searchRoomVisible = false;
          var anchor = this.$el.querySelector('#r' + sno);
          document.body.scrollTop = anchor.offsetTop; // chrome
          document.documentElement.scrollTop = anchor.offsetTop; // firefox
        } catch (ex) {
          //没有找到
          this.msg2(this.$t('msg_could_not_find'));
        }
      },
      /*选中的房间*/
      selectRoom(value) {
        if (this.selectedroom.indexOf(value) != -1) {
          this.selectedroom.splice(this.selectedroom.indexOf(value), 1);
        } else if (this.selectedroom.length < this.gearRoomInfo.rmnum) {
          this.selectedroom.push(value);
        }
      },
      vShowDelete(n) {
        var data = this.confineRoom[n];
        if (data.type == 'rowDatas') {
          for (var i = 0; i < this.gearOption.rowDatas.length; i++) {
            if (this.gearOption.rowDatas[i] == data.rmnum) {
              this.gearOption.rowDatas.splice(i, 1);
              break;
            }
          }
        } else if (data.type == 'InDatas') {
          for (var i = 0; i < this.gearOption.InDatas.length; i++) {
            if (this.gearOption.InDatas[i] == data.rmnum) {
              this.gearOption.InDatas.splice(i, 1);
              break;
            }
          }
        }
        this.confineRoom.splice(n, 1);
      },
      cancelOrder() {
        MessageBox.prompt(this.$t('MessageBox_cancelOrder'), '', {
          confirmButtonText: this.$t('MessageBox_confirmButtonText'),
          cancelButtonText: this.$t('MessageBox_cancelButtonText')
        })
          .then(({
                   value,
                   action
                 }) => {
            this.$http
              .post('/mobilepmsapi/reception/cancelOrder', {
                id: this.orderInfo.masterBase.id,
                rsvId: this.orderInfo.masterBase.rsvId,
                reason: value
              })
              .then(res => {
                if (res.data.result == 0) {
                  //取消成功
                  this.msg2(this.$t('msg_cancel_success'));
                  this.getOrderDetail();
                } else {
                  this.msg2(res.data.msg);
                }
              });
          })
          .catch(action => {
          });
      },
      /*选中的房间选择排房、入住*/
      pushSelected(value) {
        for (var i = 0; i < this.confineRoom.length; i++) {
          for (var n = 0; n < this.selectedroom.length; n++) {
            if (this.confineRoom[i].rmnum == this.selectedroom[n]) {
              //
              this.msg2(
                this.$t('orderDetail_room') +
                this.selectedroom[n] +
                this.$t('orderDetail_has_chosen')
              );
              return;
            }
          }
        }

        if (this.selectedroom.length > 0) {
          if (
            this.gearOption.rowDatas.length +
            this.gearOption.InDatas.length +
            this.selectedroom.length >
            this.gearRoomInfo.rmnum
          ) {
            //msg_no_more_room 超过本次允许的房间数
            this.msg2(this.$t('msg_no_more_room'));
            return;
          }
          if (value == 0) {
            //排房
            _.forEach(this.selectedroom, (el, key) => {
              this.confineRoom.push(_.merge({}, {
                rmnum: el,
                type: 'rowDatas'
              }));
              this.gearOption.rowDatas.push(el);
            });
          } else if (value == 1) {
            //入住
            _.forEach(this.selectedroom, (el, key) => {
              this.confineRoom.push(_.merge({}, {
                rmnum: el,
                type: 'InDatas'
              }));
              this.gearOption.InDatas.push(el);
            });
          }
          this.selectedroom = [];
        } else {
          this.msg2(this.$t('msg_choose_room'));
        }
      },
      /*提交排房/入住信息*/
      submitGear() {
        if (
          this.gearOption.InDatas.length == 0 &&
          this.gearOption.rowDatas.length == 0
        ) {
          //msg_submitGear 请先点击排房或入住按钮
          this.msg2(this.$t('msg_submitGear'));
          return;
        }
        this.$http
          .post('/mobilepmsapi/reception/finishRowHouse', this.gearOption)
          .then(res => {
            if (res.data.result == 0) {
              this.popupVisible = false;
              // console.log("提交排房入住成功");
              this.getOrderDetail();
            } else {
              this.msg2(res.data.msg);
            }
            // console.log(res.data);
          });
      },

      /*关闭排房界面返回详情页*/
      canclePop() {
        this.popupVisible = false;
        this.selectedroom = [];
      },
      /*入住房间*/
      checkIn(value) {
        //console.log(value);
        this.confirm2(this.$t('MessageBox_checkIn'), action => {
          this.$http
            .post('/mobilepmsapi/reception/finishRowHouseCheckIn', {
              rsvId: this.orderInfo.masterBase.rsvId,
              InDatas: [value]
            })
            .then(res => {
              if (res.data.result == 0) {
                this.getOrderDetail();
              } else {
                this.msg2(res.data.msg);
              }
            })
        })
      },
      /*添加入住人信息*/
      addGuest(link) {
        this.updateGuest = link;
        this.guestPopVisible = true;
      },
      /*改变入住人信息*/
      changGuest() {
        this.guestPopVisible = false;
        let guestinfo = [];

        guestinfo.push({
          id: this.updateGuest.masterBase.id,
          name: this.updateGuest.masterGuest.name,
          idNo: this.updateGuest.masterGuest.idNo,
          mobile: this.updateGuest.masterGuest.mobile
        });
        // console.log(guestinfo);
        this.$http
          .post('/mobilepmsapi/reception/updateMasterGuest', guestinfo)
          .then(res => {
            if (res.data.result == 0) {
              //修改成功
              this.msg2(this.$t('msg_modify_success'));
              this.guestPopVisible = false;
            } else {
              this.msg2(res.data.msg);
            }
          });
      },
      /*关闭入住人信息弹框*/
      cancleGuestPop() {
        this.guestPopVisible = false;
        this.getOrderDetail();
      },
      //显示预订支付二维码弹窗
      showQrcodeModal(){
        let _masterId = this.orderInfo.masterBase.id;
        this.$refs.formQrCodeModal.show(_masterId);
      },
      emitFormQrCode(data){
        this.$refs.qrCodeModal.show({
          ...data,
          name: this.orderInfo.masterGuest.name,
          arr: this.orderInfo.masterBase.arr
        });
      }
    },
    filters: {
      dateF(value) {
        return value != '' ? value.replace(/-/g, '/').substring(5, 10) : '';
      },
      dateD(value) {
        return value != '' ? value.replace(/-/g, '/').substring(5, 16) : '';
      },
      showConfine(value) {
        return !!value == true ? value.rmnum : '';
      }
    },
    components: {
      updateRemark, selectShift, jingJiangModal,
      formQrCodeModal,
      qrcodeModal
    }
  };
</script>

<style lang="less">
  .orderDetail {
    background: #f7f8fa;

    .print-select-modal {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      z-index: 1111;

      .modal-container {
        padding: 15px;
        padding-bottom: 0;

        .spe-row {
          display: flex;
          justify-content: space-between;

          .btn-default {
            display: inline-block;
            border: 1px solid #ddd;
            text-align: center;
            font-size: 14px;
            border-radius: 4px;
            padding: 10px 0;
            box-sizing: border-box;
            width: 45%;
            margin-bottom: 15px;

            &:active {
              background: #eee;
            }
          }
        }
      }

      .door-card-container {
        overflow: hidden;
        position: fixed;
        width: 80%;
        background: #fff;
        z-index: 12;
        border-radius: 10px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 14px;

        .door-card-title {
          height: 40px;
          line-height: 40px;
          border-bottom: 1px solid #eee;
          text-align: center;
        }

        .door-card-bottom {
          height: 45px;
          line-height: 45px;
          border-top: 1px solid #eee;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .door-btns {
            flex: 1;
            text-align: center;
            display: inline-block;
            box-sizing: border-box;
            border-right: 1px solid #eee;

            &:last-child {
              border-right: none;
            }
          }

        }
      }
    }

    .door-card-modal {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      z-index: 1111;

      .door-card-container {
        overflow: hidden;
        position: fixed;
        width: 80%;
        background: #fff;
        z-index: 12;
        border-radius: 10px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 14px;

        .door-card-title {
          height: 40px;
          line-height: 40px;
          border-bottom: 1px solid #eee;
          text-align: center;
        }

        .door-card-info {
          box-sizing: border-box;
          height: 140px;

          .info-item {
            padding: 10px 15px;
            display: flex;

            .info-item-label {
              color: #333;
              width: 80px;
            }

            .info-item-content {
              color: #666;
            }
          }
        }

        .door-card-bottom {
          height: 45px;
          line-height: 45px;
          border-top: 1px solid #eee;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .door-btns {
            flex: 1;
            text-align: center;
            display: inline-block;
            box-sizing: border-box;
            border-right: 1px solid #eee;

            &:last-child {
              border-right: none;
            }
          }

        }
      }
    }

    .warp {
      margin: 10px auto;
      background: #f6f8f9;

      .orderSta {
        background-color: #f6f8f9;
        height: 32px;
        line-height: 26px;
        color: #333;

        .Num {
          float: left;
          margin-left: 8px;
        }

        .sta {
          float: right;
          margin-right: 8px;

          span {
            color: #ffffff;
            font-weight: bold;
            font-size: 16px;
            border-radius: 12px;
            display: inline-block;
            width: 22px;
            height: 22px;
            text-align: center;
            background: #646f83;
            vertical-align: middle;
            line-height: 22px;
          }
        }
      }

      .infoList {
        margin: 0 10px;
        background: #fff;
        box-shadow: 0 -2px 20px rgba(0, 0, 0, 0.15);
        border-radius: 4px;

        .info {
          padding: 10px 0;

          .infoTop {
            padding: 0 18px;
            position: relative;
            height: 20px;
            line-height: 20px;

            .icon-changfangxingbiaoqian {
              position: absolute;
              font-size: 12px;
              left: 0;
              top: 1px;
              color: #f6a624;
            }
          }

          .infoContent {
            margin: 0 20px;
            padding: 10px 0;
            border-bottom: 1px dashed #ddd;
            clear: both;

            .ha {
              height: auto;
            }

            .mintui-more {
              color: #aaa;
              font-size: 12px;
              margin-left: 10px;
            }

            .p100 {
              clear: both;
              width: 100% !important;
            }

            li {
              margin: 2px auto;
              line-height: 20px;

              .infoVal {
                margin-left: 8px;

                .icon-xiugai {
                  padding: 0.2rem 0.3rem;
                  color: #f6a624;
                }
              }

              .addGuest {
                float: right;
                background-color: #f6a624;
                border-radius: 50%;
                width: 20px;
                height: 20px;
                text-align: center;

                .iconfont {
                  color: #fff;
                  font-size: 12px;
                  line-height: 20px;
                }
              }

              .paiF, .menka,
              .ruZ {
                height: 32px;
                width: 60px;
                float: right;
                text-align: center;
                line-height: 32px;
                background-color: #f4f4f4;
                position: relative;
                border: 1px solid #ddd;
                border-radius: 4px;
                margin-left: 5px;
              }

              .menka,
              .ruZ {
                background-color: #f6a624;
                color: #fff;
              }
            }

            &.twocol {
              overflow: hidden;

              li {
                width: 50%;
                float: left;
              }
            }
          }

          .totalmoney {
            margin: 0 20px;
            height: 30px;
            line-height: 30px;

            span {
              margin-left: 0;
            }
          }
        }
      }
    }

    .setroom {
      z-index: 101 !important;
      height: 100%;
      width: 100%;
      background-color: #fff;

      .infoTitle {
        height: 1.3333rem;
        text-align: center;
        font-size: 14px;
        line-height: 1.3333rem;
      }

      .top {
        line-height: 1.066667rem;
        font-size: 16px;
        text-align: center;
        padding: 0 15px;
        height: 1.066667rem;
        background: #393c41;
        color: #fff;
        text-align: center;
        border-bottom: 1px solid #eee;

        .iconfont {
          line-height: 1.066667rem;
          font-size: 0.4rem;
          float: left;
        }

        .sureGear {
          float: right;
        }
      }

      .optional {
        padding: 10px 12px;

        .option {
          margin: 0.125rem;
          height: 1rem;
          width: 2rem;
          float: left;
          border: 1px solid #aaa;
          border-radius: 2px;
          text-align: center;
          font-size: 0.37rem;
          line-height: 1rem;
          color: #999;
          position: relative;
          background-color: #fff;

          &.choose {
            background-color: #d3d3d3;
          }

          .cleartext {
            position: absolute;
            right: -0.15rem;
            bottom: -0.28rem;
            display: block;

            i.icon-cuowu {
              line-height: 0.32rem;
              background-color: #c3c3c3;
              border-radius: 50%;
              font-size: 0.32rem;
              text-align: center;
              color: #fff;
              padding: 0.13333333rem;
              margin-top: 0.13333333rem;
              -webkit-transform-origin-x: 0;
              transform: scale(0.6);
              -webkit-transform: scale(0.6);
              width: 0.32rem;
              display: inline-block;
            }
          }
        }

        &.selected {
          .option {
            border: 1px dashed #aaa;

            &.InDatas {
              background-color: #428fc8;
              color: #fff;
            }

            &.rowDatas {
              background-color: #00c05a;
              color: #fff;
            }
          }
        }
      }

      .room-status-select {
        padding: 10px 12px;
        padding-top: 20px;
        display: flex;
        align-items: center;
        border-top: 1px solid #eaeaea;

        .status-select-title {
          margin: 0.125rem;
          font-size: 14px;
          margin-right: 15px;
        }

        .status-item {
          display: inline-block;
          border: 1px solid #999;
          padding: 8px 10px;
          margin-right: 10px;

          &.active {
            background: #333;
            color: #ffffff;
          }
        }
      }

      .bottom {
        position: absolute;
        bottom: 0;
        width: 100%;

        .plan {
          float: left;
          height: 50px;
          line-height: 50px;
          width: 50%;
          background: #00c05a;
          color: #fff;
          font-size: 16px;
          text-align: center;
          border-right: 1px solid #fff;
          box-sizing: border-box;
        }

        .checkIn {
          box-sizing: border-box;
          border-left: 1px solid #fff;
          float: left;
          height: 50px;
          line-height: 50px;
          width: 50%;
          background: #428fc8;
          color: #fff;
          font-size: 16px;
          text-align: center;
        }
      }
    }

    .guestInfo {
      width: 90%;
      height: 340px;
      position: absolute;
      margin: 0 auto;
      background-color: #fff;
      border-radius: 10px;

      &.base-spe{
        height: 250px;
      }
      h2 {
        font-size: 18px;
        color: #666666;
        text-align: center;
        font-style: normal;
        padding: 20px 0;
      }

      .mint-cell-title {
        width: 80px;
      }

      .guestSwiper {
        padding: 0 4%;

        p {
          font-size: 18px;
          color: #57b658;
          padding: 20px 0 20px 5px;
        }
      }

      .btn {
        height: 55px;
        border-top: 1px solid #bdbdbd;
        text-align: center;
        font-size: 16px;
        position: absolute;
        bottom: 0;
        width: 100%;

        .unSure {
          border-right: 1px solid #bdbdbd;
          width: 50%;
          box-sizing: border-box;
          float: left;
          line-height: 55px;
        }

        .sure {
          width: 50%;
          box-sizing: border-box;
          float: left;
          line-height: 55px;
          color: #5190c3;
        }
      }
    }

    .everyDatePop {
      width: 100%;
      height: 50%;
      overflow-y: scroll;

      .checkList {
        width: 100%;

        tr {
          background-color: #fff;

          &:nth-of-type(2n) {
            background-color: #f5f5f5;
          }

          font-size: 0.32rem;

          th {
            color: #fff;
            height: 1.06666667rem;
            text-align: center;
            font-size: 0.34666667rem;
            background-color: #f69c2c;
            padding: 0;
          }

          td {
            height: 1.06666667rem;
            padding: 0px;
            text-align: center;
          }
        }
      }
    }

    .pb {
      width: 60px;
      height: 60px;
      line-height: 60px;
      color: #fff;
      position: absolute;
      bottom: 30px;
      z-index: 1;
    }

    .my-icon-button {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      background-color: #f6a624;
      color: #fff;
      line-height: 30px;
      text-align: center;
    }

    .mint-main-button {
      color: #000;
      background-color: #f6a624;
    }

    .dx {
      text-align: center;
      height: 40px;
      margin-top: 20px;
      line-height: 20px;
      color: #eee;

      span {
        color: #ddd;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// orderDetail.vue?b0e941f2